export const Accordion = (function () {
	'use strict';

	var $allPanels, $allButtons, $allFcBlocks, $allGPGAccordion;

	function init() {
		$allPanels = $('.help-graph__accordion > dd');
		$allButtons = $('.help-graph__accordion button');
		$allPanels.hide();
		events();
		// console.log($allFcBlocks);
		$allFcBlocks = $('.help-graph').find('.fc-block');
		if($allFcBlocks.length > 0) {
			fcBlocks();
		}
		// console.log($allFcBlocks);
		$allGPGAccordion = $('.gpg-accordion');
		if($allGPGAccordion.length > 0) {
			gpgAccordion();
		}
	}

	function events() {
		$('.help-graph__accordion > dt > button').click(function() {
			if( $(this).hasClass('active') ) {
				$allPanels.slideUp();
				$allButtons.removeClass('active');
				return false
			};

			$allPanels.slideUp();
			$allButtons.removeClass('active');
			$(this).addClass('active');
			$(this).parent().next().slideDown();
			return false;
		});
	}

	function gpgAccordion() {
		$allGPGAccordion.find('dd').hide();
		// console.log($allFcBlocks);
		$allGPGAccordion.each(function(){
			let $fcBlock = $(this);

			$fcBlock.find('dt').on('click', function(){
				// console.log($fcBlock);
				if( $(this).hasClass("active") ) {
					$fcBlock.find('dt').removeClass('active');
					$fcBlock.find('dd').slideUp();
					return;
				};
				$allGPGAccordion.find('dd').slideUp();
				$allGPGAccordion.find('dt').removeClass('active');
				$(this).addClass('active');
				$(this).next().slideDown();
			});
			// return false;
		});
	}

	function fcBlocks() {
		$allFcBlocks.find('dd').hide();
		// console.log($allFcBlocks);
		$allFcBlocks.each(function(){
			let $fcBlock = $(this);

			$fcBlock.find('dt').on('click', function(){
				// console.log($fcBlock);
				if( $(this).hasClass("active") ) {
					$fcBlock.find('dt').removeClass('active');
					$fcBlock.find('dd').slideUp();
					return;
				};
				$allFcBlocks.find('dd').slideUp();
				$allFcBlocks.find('dt').removeClass('active');
				$(this).addClass('active');
				$fcBlock.find('dd').slideDown();
			});
			// return false;
		});
	}

	return {
		init: init,
	};
})();
